// Ajout au panier instantané (WEBLCFB2C-202, 07/10).
// Mesuré : Shopify met 450-650 ms à répondre à un ajout (remises automatiques évaluées à chaque fois), le
// tiroir s'ouvrait donc ~0,6 s après le clic, avec la barre de chargement en haut. Ici on ouvre le tiroir
// dès le clic et on y montre la ligne « en cours » (photo + titre du produit cliqué) ; le rendu de Shopify la
// remplace à l'arrivée (cart:change). On n'intercepte rien : l'envoi reste celui du thème.
(() => {
  const TIMEOUT = 10000;
  let timer = null;

  const drawer = () => document.querySelector('cart-drawer.df-cart');
  const esc = (text) => String(text ?? '').replace(/[&<>"']/g, (c) => `&#${c.charCodeAt(0)};`);

  function stop() {
    window.clearTimeout(timer);
    document.documentElement.classList.remove('df-cart-adding');
    drawer()?.querySelectorAll('.df-cart__pending').forEach((row) => row.remove());
  }

  function start({ title = '', image = '' } = {}) {
    const cart = drawer();
    if (!cart) return;
    stop();
    document.documentElement.classList.add('df-cart-adding');

    const row = document.createElement('div');
    row.className = 'df-cart__pending';
    row.setAttribute('aria-busy', 'true');
    row.innerHTML = `
      <div class="df-cart__pending-media">${image ? `<img src="${esc(image)}" alt="">` : ''}</div>
      <div class="df-cart__pending-info">
        <p class="df-cart__pending-title">${esc(title)}</p>
        <span class="df-cart__pending-bar"></span>
        <span class="df-cart__pending-bar df-cart__pending-bar--short"></span>
      </div>`;

    const items = cart.querySelector('.cart-drawer__items');
    if (items) items.prepend(row);
    else cart.prepend(row);

    cart.show?.();
    timer = window.setTimeout(stop, TIMEOUT);
  }

  // Ce que montre la ligne « en cours » : la carte ou la pop-up d'où part l'ajout, sinon la fiche produit.
  function describe(form) {
    const box = form.closest('.df-product-card, .product-card, quick-buy-modal, .quick-buy-modal');
    if (box) {
      const img = box.querySelector('img');
      const name = box.querySelector('.product-title, .h5, .h6, h2, h3');
      return { title: name?.textContent.trim() || '', image: img?.currentSrc || img?.src || '' };
    }
    const meta = (property) => document.querySelector(`meta[property="${property}"]`)?.content || '';
    return { title: meta('og:title'), image: meta('og:image') };
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    // Look errors belong to the still-visible Look drawer; open the cart only on success.
    if (form.closest('cart-drawer, .look-card')) return;
    start(describe(form));
  }, true);

  document.addEventListener('cart:change', stop);
  document.addEventListener('cart:error', stop, true);

  // Chemins d'ajout qui ne passent pas par un formulaire (« + » du tiroir, ajout fantôme de la fiche V3)
  window.dfCartPending = { start, stop };
})();
